<div class="pagination-container">
  <button mat-icon-button (click)="goToPreviousPage()" [disabled]="currentPage === 1">
    <mat-icon>chevron_left</mat-icon>
  </button>

  <ng-container *ngFor="let page of visiblePages">
    <ng-container *ngIf="page === -1">
      <span class="ellipsis">...</span>
    </ng-container>
    <ng-container *ngIf="page !== -1">
      <button mat-button (click)="goToPage(page)" [disabled]="page === currentPage"
        [class.current-page]="page === currentPage">
        {{ page }}
      </button>
    </ng-container>
  </ng-container>



  <span class="ellipsis" *ngIf="showEllipsis">..........</span>

  <button mat-button *ngIf="!visiblePages.includes(totalPages)" (click)="goToPage(totalPages)"
    [disabled]="currentPage === totalPages">
    {{ totalPages }}
  </button>
  <button mat-icon-button (click)="goToNextPage()" [disabled]="currentPage === totalPages">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>